module.exports = __webpack_public_path__ + "static/cg_role_178_0006e7112ac.wav";